import img1 from "../Images/Profile_pic.jpg";

const testimonials = [
  {
    id: 1,
    name: "Karthik Hadapad",
    image: img1,
    description:
      "I had been avoiding the dentist for years out of fear, but my experience here completely changed that. From the receptionist to the hygienist and dentist, everyone was incredibly kind and reassuring. The procedure was painless, and they made sure I was comfortable the entire time. I finally feel confident about going to the dentist again.",
  },
  {
    id: 2,
    name: "A J Suhas",
    image: img1,
    description:
      "After struggling with dental issues for a long time, I decided to try this clinic — and I’m so glad I did! The doctors are extremely professional, and they explained my treatment plan in simple terms. I received a root canal and crown, and the results are fantastic. The clinic is clean, modern, and welcoming.",
  },
  {
    id: 3,
    name: "TSubhanu Sharma",
    image: img1,
    description:
      "This is by far the best dental clinic I've ever been to. I had cosmetic dental work done and the transformation was incredible. The dentist paid close attention to detail and made sure I was happy with every step of the process. Now I smile more than ever, and I constantly get compliments on my teeth.",
  },
  {
    id: 4,
    name: "⁠Ankita Vaz",
    image: img1,
    description:
      "As someone with sensitive teeth, I was worried about getting a cleaning. But the hygienist was gentle, and the process was smooth and pain-free. They also gave me useful tips on how to care for my gums at home. It’s clear that patient care is a top priority here.",
  },
  {
    id: 5,
    name: "⁠Roopa Naik",
    image: img1,
    description:
      "I had multiple missing teeth and finally decided to get implants. The consultation was thorough, and I never felt rushed. The surgery went well, and recovery was quicker than expected. I now eat and speak with much more confidence. Thank you for restoring my quality of life!",
  },
];

export default testimonials;
